/**
 * What a phone remembers having done on this match — predicted, voted,
 * answered the survey — so the fan page shows the "already done" screen
 * without asking the server. On a TEST SEAT (`seats.is_test`) nothing is
 * remembered: staff redo these things to test, the server rows are the only
 * truth there, and `fans-sim.mjs <club> reset-test-seat` clears those.
 */
export interface FanMemory {
  get: (key: string) => string | null;
  set: (key: string, value: string) => void;
  remove: (key: string) => void;
}

const quiet = <T>(fn: () => T, fallback: T): T => { try { return fn(); } catch { return fallback; } };

export function fanMemory(isDemoSeat: boolean): FanMemory {
  if (isDemoSeat) return { get: () => null, set: () => {}, remove: () => {} };
  return {
    get: (key) => quiet(() => localStorage.getItem(key), null),
    set: (key, value) => quiet(() => localStorage.setItem(key, value), undefined),
    remove: (key) => quiet(() => localStorage.removeItem(key), undefined),
  };
}
